import PublicLayout from "../../modules/ui/components/PublicLayout";
import BgGlassmorphism from "../../modules/ui/components/BgGlassmorphism/BgGlassmorphism";
import TransferList from "../../modules/transfers/components/list/TransferList";
import React from "react";

const PageTransfers = () => {
    return (
        <PublicLayout>
            <div className="nc-PageHome relative overflow-hidden mt-4">
                <BgGlassmorphism />
                <div className="container relative space-y-5 mb-24 lg:space-y-5">
                    <TransferList/>
                </div>
            </div>
        </PublicLayout>
    );
}

export default PageTransfers;
